// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1kITt","label":"CategoryService_label__2vuxL","location":"CategoryService_location__3a9xq"};